import { semanticColors } from '@moderneinc/design-system-tokens';
import { TabPanel } from '@mui/lab';
import { styled } from '@mui/material';

export const ModerneTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: 0,
  paddingTop: theme.spacing(2),
  // Tab content sits on the page canvas, not a card. `background.paper` flips to
  // the card surface (#26262e) in dark; canvasContent is #1b1b21 (the content
  // area). Light-safe: both are #fbfaf6.
  backgroundColor: semanticColors.color.surface.canvas
}));
